<template>
  <!-- 分组设置弹窗 -->
  <div class="vmp-group-setting">
    <vh-dialog
      :visible.sync="dialogVisible"
      @open="handleOpen"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :append-to-body="false"
      width="480px"
      :title="$t('host.k_552001')"
    >
      <div class="vmp-group-form">
        <div class="vmp-group-item group-number">
          <div class="vmp-group-item__hd">{{ $t('host.k_552002') }}</div>
          <div class="vmp-group-item__bd">
            {{ $t('host.k_552003', { n: userNumber }) }}
            <vh-input
              :disabled="way == 3"
              style="width: 60px; margin: 0 6px"
              clearable
              maxlength="2"
              placeholder="2-50"
              type="number"
              v-model.number.trim="count"
              @input="validCount"
              class="group-number__input"
            ></vh-input>
            {{ $t('host.k_552004') }}
          </div>
        </div>
        <div class="vmp-group-item group-way">
          <div class="vmp-group-item__hd">{{ $t('host.k_552005') }}</div>
          <div class="vmp-group-item__bd">
            <vh-radio class="group-radio" v-model="way" label="1">
              {{ $t('host.k_552006') }}
            </vh-radio>
            <vh-radio class="group-radio" v-model="way" label="2">
              {{ $t('host.k_552007') }}
            </vh-radio>
            <!-- <vh-radio class="group-radio" v-model="way" label="3" :disabled="verify != 2">
            白名单预设分组（按照白名单观众组中的小组分配）
          </vh-radio> -->
          </div>
        </div>

        <!-- 底部按钮 -->
        <div class="vmp-group-ft">
          <vh-button type="info" plain round @click="handleClose">
            {{ $t('host.k_552008') }}
          </vh-button>
          <vh-button type="primary" round @click="handleGroup">{{ $t('host.k_552009') }}</vh-button>
        </div>
      </div>
    </vh-dialog>
  </div>
</template>
<script>
  import { useRoomBaseServer, useGroupServer, useMemberServer } from 'middle-domain';
  export default {
    name: 'VmpGroupSetting',
    props: {
      show: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        dialogVisible: this.show,
        count: '', // 分组数量，2~50 之间
        way: '1' // 分组方式，1=随机分配|2=手动分配|3=预分组
      };
    },

    beforeCreate() {
      this.roomBaseServer = useRoomBaseServer();
      this.groupServer = useGroupServer();
      this.memberServer = useMemberServer();
    },
    computed: {
      //观看限制白名单，白名单预设分组可设置，其他则不可选
      verify() {
        return this.roomBaseServer.state.watchInitData.webinar.verify;
      },
      // 观众数量
      userNumber() {
        return this.memberServer.state.onlineUsers.filter(item => item.role_name == 2).length;
      }
    },
    watch: {
      show: function (newVal) {
        this.dialogVisible = newVal;
      }
    },
    methods: {
      validCount(v) {
        if (v.length > 2) {
          this.count = v.slice(0, 2);
        }
      },
      handleOpen() {
        this.count = '';
        this.way = '1';
      },
      // 开始分组
      handleGroup: async function () {
        console.log('this.count:', this.count);
        if (this.way != 3 && (isNaN(this.count) || this.count < 2 || this.count > 50)) {
          this.$message.warning(this.$t('host.k_552010'));
          return false;
        }
        try {
          const { watchInitData = {} } = this.roomBaseServer.state;
          const interactToken = watchInitData?.interact?.interact_token;
          interactToken && sessionStorage.setItem('interact_token', interactToken);
          const result = await this.groupServer.groupCreate({
            number: this.count,
            way: this.way,
            switch_id: watchInitData.switch.switch_id,
            webinar_id: watchInitData.webinar.id
          });
          if (result && result.code === 200) {
            this.count = '';
            this.$emit('settingCancel', this.way);
            this.close();
          } else {
            this.$message.warning(result.msg || this.$t('host.k_552011'));
          }
        } catch (ex) {
          this.$message.warning(ex.messge || this.$t('host.k_552012'));
        }
      },
      // 取消
      handleClose() {
        this.close();
      },
      close() {
        this.dialogVisible = false;
        this.$emit('update:show', false);
      }
    }
  };
</script>
<style lang="less">
  .vmp-group-setting {
    .vh-dialog__body {
      padding: 0 30px 30px 30px;
    }
    .vmp-group-form {
      display: flex;
      flex-direction: column;

      .vmp-group-item {
        display: block;
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #1a1a1a;
        font-size: 14px;

        .vmp-group-item__hd {
          width: 90px;
        }

        &.group-number {
          .group-number__input.vh-input--suffix .vh-input__inner {
            padding-right: 0;
          }
        }
        &.group-way {
          margin-top: 30px;
          .vmp-group-item__hd {
            align-self: flex-start;
          }
          .vmp-group-item__bd {
            .group-radio {
              display: block;
              height: 22px;
              line-height: 22px;
              font-weight: normal;
              color: #666;
              padding-bottom: 16px;
            }
            .vh-radio__input.is-checked + .vh-radio__label {
              color: #666 !important;
            }
          }
        }
      }

      .vmp-group-ft {
        margin-top: 24px;
        text-align: right;
      }
    }
  }
</style>
